<template>
<div class="LimitTimeList">
    <div class="filters">
        <div class="add">
            <el-button type="primary" @click="handleAdd">创建限时折扣</el-button>
        </div>
        <div class="search">
            <el-select v-model="param.status" placeholder="活动状态" class="condition" clearable>
                <el-option v-for="item in limittimeList" :key="item.code" :label="item.name"
                           :value="item.code"></el-option>
            </el-select>
            <el-input v-model="param.assetname" placeholder="请输入活动名称" class="condition" clearable></el-input>
            <el-button type="primary" plain @click="handleQuery">搜索</el-button>
        </div>
    </div>
    <div class="result-list btn-operate-list bgc">
        <el-table :data="tableData" style="width: 100%;">
            <el-table-column label="活动名称" class-name="left" min-width="150">
                <template slot-scope="scope"><div>{{scope.row.assetname}}</div></template>
            </el-table-column>
            <el-table-column label="有效时间" min-width="140" class-name="center">
                <template slot-scope="scope">
                    <div class-name="center">{{scope.row.begintime}}</div>
                    <div class-name="center">-</div>
                    <div class-name="center">{{scope.row.endtime}}</div>
                </template>
            </el-table-column>
            <el-table-column label="活动状态" prop="status" class-name="center">
                <template slot-scope="scope"><div :class="status(scope.row.status)">{{scope.row.status | statusname}}</div></template>
            </el-table-column>
            <el-table-column label="商品数" prop="productcount" class-name="center"></el-table-column>
            <el-table-column label="浏览量" prop="viewcount" class-name="center"></el-table-column>
            <el-table-column label="访客量"  prop="viewcustomercount" class-name="center"></el-table-column>
            <el-table-column label="购买量"  prop="ordersucccount" class-name="center"></el-table-column>
            <el-table-column label="实收金额" prop="paymoney" class-name="center"></el-table-column>
            <el-table-column label="创建时间" prop="datetime" class-name="center"></el-table-column>
            <el-table-column label="操作" width="130" class-name="right" label-class-name="tr">
                <template slot-scope="scope">
                    <div class="tr">
                        <span class="separator-btn" v-if="[0, 1].indexOf(scope.row.status) > -1">
                            <el-button @click="handleEdit(scope.row)" type="text" size="small">编辑</el-button>
                        </span>
                        <span class="separator-btn" v-if="[0, 1].indexOf(scope.row.status) > -1">
                            <el-button @click="handleStop(scope.row)" type="text" size="small">停止</el-button>
                        </span>
                        <span class="separator-btn" v-if="[0, 1].indexOf(scope.row.status) > -1">
                            <el-button @click="handleDel(scope.row)" type="text" size="small">删除</el-button>
                        </span>
                        <span class="separator-btn" v-if="[10, 100].indexOf(scope.row.status) > -1">
                            <el-button @click="handleView(scope.row)" type="text" size="small">查看</el-button>
                        </span>
                    </div>
                </template>
            </el-table-column>
        </el-table>
        <page :total="total" @getList="_getList" ref="page"></page>
    </div>
</div>
</template>

<script>
import {mapGetters, mapActions} from 'vuex'
import Page from 'base/page/page'
import {_setClass, limitTime, _filter} from 'api/enumCode'
import {getLimitList, editLimitStatus} from 'api/operateToolApi'
export default {
    name: 'LimitTimeList',
    data() {
        return {
            param: {
                status: '',
                assetname: ''
            },
            total: 0,
            limittimeList: limitTime.status,
            tableData: [],
            power: []
        }
    },
    mounted() {
        this.power = this.permission.btnObj.A0204 ? this.permission.btnObj.A0204 : []
        this._getList()
    },
    methods: {
        handleQuery() {
            this.$refs.page.handleSizeChange(1)
        },
        handleAdd() {
            this.$router.push({name: 'LimitTimeEdit'})
        },
        handleEdit(row) {
            this.$router.push({name: 'LimitTimeEdit', query: {id: row.eventinnerid}})
        },
        handleView(row) {
            this.$router.push({name: 'LimitTimeEdit', query: {id: row.eventinnerid}})
        },
        handleStop(row) {
            let obj = {
                eventinnerid: row.eventinnerid,
                status: 10
            }
            this.$confirm('结束后，商品将恢复原价售卖，是否提前结束该限时折扣活动？', '提示', {
                confirmButtonText: '确定',
                cancelButtonText: '取消'
            }).then(() => {
                this._editStatus(obj)
            }).catch(() => {})
        },
        handleDel(row) {
            let obj = {
                eventinnerid: row.eventinnerid,
                status: 100
            }
            this.$confirm('确定删除该活动', '提示', {
                confirmButtonText: '确定',
                cancelButtonText: '取消'
            }).then(() => {
                this._editStatus(obj)
            }).catch(() => {})
        },
        _editStatus(obj) {
            this.setLoading(true)
            editLimitStatus({
                data: obj,
                success: data => {
                    this.$message.success(`${obj.status==10?'停止活动':'删除活动'}成功`)
                    this.setLoading(false)
                    this._getList()
                },
                error: data => {
                    this.setLoading(false)
                    this.$message.error(data.msg)
                    this._getList()
                }
            })
        },
        _getList() {
            this.setLoading(true)
            getLimitList({
                data: Object.assign({}, this.param, this.page),
                success: data => {
                    this.tableData = data.data.content
                    this.total = data.data.pageinfo.rowCount
                    this.setLoading(false)
                },
                error: data => {
                    this.setLoading(false)
                    this.$message.error(data.msg)
                }
            })
        },
        ...mapActions([
            'setLoading',
            'setParams',
            'setPage',
            'setIsRefresh'
        ])
    },
    filters: {
        statusname: function (value) {
            return _filter(value, limitTime.status)
        }
    },
    watch: {},
    computed: {
        status () {
            return function(value) {
                return _setClass(value, limitTime.status)
            }
        },
        ...mapGetters([
            'page',
            'user',
            'permission',
            'params',
            'isRefresh'
        ])
    },
    components: {
        Page
    }
}
</script>

<style lang="scss" type="text/scss" rel="stylesheet/scss">
.LimitTimeList {
    .center{
        text-align: center;
    }
}
</style>
